import { allEnumValues, ModelType, UserRight, UserRightHelper } from '@biteinc/enums';
import { userRoleSchema } from '@biteinc/schemas';

import {
  descriptionFromAssignableUserRight,
  nameFromAssignableUserRight,
} from '../helpers/user_right_helper';

app.UserRole = app.AbstractModel.extend({
  ModelName: 'userRole',
  Schema: userRoleSchema,
  Type: ModelType.UserRole,

  canBeDestroyed() {
    return (
      app.AbstractModel.prototype.canBeDestroyed.apply(this, arguments) && app.sessionUser.isAdmin()
    );
  },

  getFieldCollection(field, _subProperty, _includeAllValues, _keyModel) {
    switch (field) {
      case 'rights': {
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: UserRight,
          nameGenerator: (right) => {
            const rightName = nameFromAssignableUserRight(right);
            const prereqs = UserRightHelper.getDirectPrerequisites(right).map((prereq) => {
              return `- ${nameFromAssignableUserRight(prereq)}`;
            });
            if (prereqs.length) {
              const tooltipText = `Prerequisites:\n${prereqs.join('\n')}`;
              return `<span data-bs-toggle="tooltip" data-bs-title="${tooltipText}">${rightName}</span>`;
            }
            return rightName;
          },
          disclaimerGenerator: (right) => {
            return descriptionFromAssignableUserRight(right);
          },
          sort: app.AbstractCollection.SortOptions.AS_IS,
          values: allEnumValues(UserRight)
            .filter((right) => {
              return (
                app.sessionUser.hasRight(right) &&
                !UserRightHelper.isBiteRight(right) &&
                !UserRightHelper.isApiTokenRight(right)
              );
            })
            .sort((a, b) => {
              const aPrerequisiteCount = UserRightHelper.getAllPrerequisites(a).length;
              const bPrerequisiteCount = UserRightHelper.getAllPrerequisites(b).length;
              if (aPrerequisiteCount && bPrerequisiteCount) {
                return aPrerequisiteCount - bPrerequisiteCount;
              }
              if (aPrerequisiteCount) {
                return 1;
              }
              if (bPrerequisiteCount) {
                return -1;
              }
              return a - b;
            }),
        });
      }
    }
    return null;
  },

  getFieldHelpers(field) {
    switch (field) {
      case 'rights': {
        return {
          isValueDisabled: (right, roleRightsArray) => {
            const roleRightsSet = new Set(roleRightsArray);

            return (
              // Just in case the user deselected a prerequisite, we cannot disable a right
              // currently selected
              !roleRightsSet.has(right) &&
              UserRightHelper.getDirectPrerequisites(right).some((prereq) => {
                return !roleRightsSet.has(prereq);
              })
            );
          },
        };
      }
    }

    return null;
  },

  fieldIsPermanent(/* field, subProperty */) {
    return !app.sessionUser.isAdmin();
  },
});
